// The case drawer's vocabulary. The backend sends codes; every sentence the drawer shows is
// written here, so the texts go through i18n and the backend never has to phrase them.

// What the network decided, finer than the list's grouped `outcome`.
export const CASE_VERDICT = Object.freeze({
  BLOCKED: "blocked",
  SHIFTED: "shifted",
  NOT_BLOCKED: "not_blocked",
  NOT_SHIFTED: "not_shifted",
  NOT_ASSESSED: "not_assessed",
  TIMEOUT: "timeout",
  REVERSED: "reversed",
  AWAITING: "awaiting"
})

// Why a dispute wasn't stopped, when it's something on our side of the exchange.
export const CASE_REASON = Object.freeze({
  NO_MATCH: "no_match",
  NO_DEVICE: "no_device"
})

export const EVIDENCE_FIELD = Object.freeze({
  IP_ADDRESS: "ip_address",
  DEVICE_ID: "device_id",
  DEVICE_FINGERPRINT: "device_fingerprint",
  ACCOUNT_ID: "account_id",
  DELIVERY_ADDRESS: "delivery_address",
  EMAIL: "email",
  PHONE: "phone",
  SHIPPING_ADDRESS: "shipping_address",
  BILLING_ADDRESS: "billing_address"
})

export const TIMELINE_EVENT = Object.freeze({
  DISPUTE_RECEIVED: "dispute_received",
  PAST_ORDERS_REQUESTED: "past_orders_requested",
  NO_PAST_ORDERS: "no_past_orders",
  PAST_ORDERS_NOT_REQUESTED: "past_orders_not_requested",
  DISPUTED_ORDER_CHECKED: "disputed_order_checked",
  DECISION: "decision",
  BLOCK_REVERSED: "block_reversed",
  AWAITING_DECISION: "awaiting_decision"
})

export const EVIDENCE_LABEL = {
  [EVIDENCE_FIELD.IP_ADDRESS]: "IP address",
  [EVIDENCE_FIELD.DEVICE_ID]: "Device ID",
  [EVIDENCE_FIELD.DEVICE_FINGERPRINT]: "Device fingerprint",
  [EVIDENCE_FIELD.ACCOUNT_ID]: "Account ID",
  [EVIDENCE_FIELD.DELIVERY_ADDRESS]: "Delivery address",
  [EVIDENCE_FIELD.EMAIL]: "Email",
  [EVIDENCE_FIELD.PHONE]: "Phone",
  [EVIDENCE_FIELD.SHIPPING_ADDRESS]: "Shipping address",
  [EVIDENCE_FIELD.BILLING_ADDRESS]: "Billing address"
}

export const VERDICT_TEXT = {
  [CASE_VERDICT.BLOCKED]: "Visa blocked the dispute.",
  [CASE_VERDICT.REVERSED]: "Visa reversed the block. The dispute continues.",
  [CASE_VERDICT.NOT_BLOCKED]: "Visa didn't block the dispute.",
  [CASE_VERDICT.TIMEOUT]: "Our response reached Visa after its 2-second limit.",
  [CASE_VERDICT.SHIFTED]: "Mastercard found compelling evidence. Liability moved to the bank.",
  [CASE_VERDICT.NOT_SHIFTED]: "Mastercard found no compelling evidence.",
  [CASE_VERDICT.NOT_ASSESSED]: "Mastercard found no matching order."
}

// Keyed by the program code; CE runs on Visa, FPT on Mastercard, and each network words its
// side of the exchange differently.
export const CASE_NETWORK_META = {
  ce: {
    network: "Visa",
    pastOrdersTitle: "Past orders Visa compared",
    pastOrdersNote: "Orders made 120–365 days before the dispute.",
    noPastOrders: "No orders 120–365 days before the dispute.",
    noPastOrdersEvent: "Visa found no past orders to compare"
  },
  fpt: {
    network: "Mastercard",
    pastOrdersTitle: "Past orders Mastercard asked about",
    pastOrdersNote: null,
    noPastOrders: "Mastercard didn't ask about past orders.",
    noPastOrdersEvent: "Mastercard didn't request past orders"
  }
}
